const JudgesComponent = () => import('@/views/kpi/judges/JudgesView')

export default [
    {
        path:'/JudgesIndex',
        name:'JudgesComponent',
        component:JudgesComponent
    }
]